<div class="d-flex align-items-center " style="padding: 20px; gap: 4px;">
    <button mat-icon-button (click)="onGoParent()">
        <mat-icon>chevron_left</mat-icon>
    </button>
    <div (click)="onGoParent()" class="mat-body-2">{{ isTableLayout() ? 'Taula' : 'Repetidor' }}</div>
    <div style="flex:1 0 0;"></div>
    <div>
        <app-chip [hasAction]="false" [label]="'ID: '+item.id" [hasClose]="false" [filledStyle]="true"></app-chip>
    </div>
</div>
<mat-divider></mat-divider>

<app-tool-help>
    <mat-icon class="material-icons-outlined" style="overflow: visible;" helpIcon>{{icon()}}</mat-icon>
    <div helpDesc>{{helpText()}}</div>
</app-tool-help>

<mat-accordion displayMode="flat" [multi]="true">

    <mat-expansion-panel [expanded]="true" class="mat-elevation-z81">

        <mat-expansion-panel-header>

            <mat-panel-description class="mat-body-2" style="color:unset">
                General
            </mat-panel-description>

        </mat-expansion-panel-header>
        <div class="d-flex flex-column">

            <app-single-field label="Nom"
                toolTipMsg="Introdueix el nom del camp del formulari. Aquest és el títol del camp que l'usuari veurà en completar el formulari."
                [fieldValue]="item.name" (fieldValueChange)="item.name = $event;fireChange();">
            </app-single-field>

            <app-single-field *ngIf="isRepeatLayout()" label="Etiqueta del botó" toolTipMsg="Posa la etiqueta que surt al botó afegir"
                [fieldValue]="item.addLabel" (fieldValueChange)="item.addLabel= $event;fireChange();">
            </app-single-field>

            <app-single-field label="Descripció" type="textarea"
                toolTipMsg="Introdueix el contigut del camp (html permes)" [fieldValue]="item.description"
                (fieldValueChange)="item.description = $event;fireChange();">
            </app-single-field>

            <app-single-field *ngIf="!isWebServiceLayout()" label="Al menys un" type="checkbox" toolTipMsg="Com a minim un element"
                [fieldValue]="item.atLeastOne" (fieldValueChange)="item.atLeastOne = $event;fireChange();">
            </app-single-field>

            <app-single-field *ngIf="isTableLayout() && !item.atLeastOne" label="Iniciar taula" toolTipMsg="Posa un text per iniciar la taula"
                [fieldValue]="item.addLabel" (fieldValueChange)="item.addLabel=$event;fireChange();">
            </app-single-field>

            @if (isWebServiceLayout()) {

                @let webServiceItem = getWebServiceItem(item);

                <app-single-field label="Format" type="text" toolTipMsg="Format"
                    [fieldValue]="webServiceItem.datasource" (fieldValueChange)="webServiceItem.datasource = $event; fireChange();">
                </app-single-field>

                <app-single-field label="Titol d'error" type="text" tooltipMsg="Titol que es mostrará si la resolució de l'endpoint no es la correcte"
                    [fieldValue]="webServiceItem.titleError" (fieldValueChange)="webServiceItem.titleError = $event; fireChange();">
                </app-single-field>

                <app-single-field label="Descripció de l'error" type="textarea" tooltipMsg="Descripció que es mostrará si la resolució de l'endpoint no es la correcte"
                    [fieldValue]="webServiceItem.descriptionError" (fieldValueChange)="webServiceItem.descriptionError = $event; fireChange();">
                </app-single-field>
            }

        </div>

    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" class="mat-elevation-z81">

        <mat-expansion-panel-header>
            <mat-panel-description class="mat-body-2" style="color:unset">
                Interoperabilitat
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="d-flex flex-column">

            <app-single-field label="Nom al JSON" [validator]="fieldNameValidator"
                toolTipMsg="És el nom que identifica al camp en el format JSON" [fieldValue]="item.fieldName"
                (fieldValueChange)="item.fieldName = $event;fireChange();">
            </app-single-field>

        </div>

    </mat-expansion-panel>

</mat-accordion>